import type { Patient } from '@medplum/fhirtypes'
import { isScribeSourceLanguage, type ScribeSourceLanguage } from '@behuman/core-contract'

/**
 * PD-1600 — the default the pre-join language picker shows: the patient's
 * stated preferred language when the scribe supports it, else English. A
 * default only — the provider confirms it before joining.
 */
// ISO 639-2 spellings an imported record may carry for the supported languages;
// the app itself writes BCP-47 two-letter codes.
const THREE_LETTER_CODES = new Map<string, ScribeSourceLanguage>([
  ['eng', 'en'],
  ['spa', 'es'],
])

export function preferredScribeLanguage(patient: Patient | undefined): ScribeSourceLanguage {
  const spoken =
    patient?.communication?.find((c) => c.preferred && c.language)?.language ??
    patient?.communication?.[0]?.language
  const raw = (spoken?.coding?.[0]?.code ?? spoken?.text ?? '').toLowerCase()
  const code = THREE_LETTER_CODES.get(raw) ?? raw.slice(0, 2)
  return isScribeSourceLanguage(code) ? code : 'en'
}
